module.exports = __webpack_public_path__ + "static/media/picto_bed.a2127a87.png";